import moment, { type MomentInput } from 'moment';

import { BaseService } from '@myhealth-raccoon/services';

import {
    AppointmentType,
    AutomedDoctorAvailablilityModel,
    AutomedDoctorDateModel,
    FirstAvailableModel,
    ServiceTypeSearchEnum,
    SiteBookingAvailabilityModel,
} from './types';

class AvailabilityService extends BaseService {
    constructor() {
        super('v1/site', import.meta.env.VITE_BP_API_URL);
    }

    public async GetAppointmentTypes(siteId: number | string, serviceType?: ServiceTypeSearchEnum) {
        const query = new URLSearchParams(
            serviceType
                ? {
                      serviceType: serviceType.toString(),
                  }
                : {}
        );
        return this.get<AppointmentType[]>(`${siteId}/availability/appointmentTypes?${query}`);
    }

    public async GetFirstAvailable(
        siteId: string | number,
        appointmentTypeId: string | number,
        doctorId: string | number | null | undefined
    ) {
        if (!appointmentTypeId) {
            return [];
        }
        const query = new URLSearchParams({
            appointmentTypeId: appointmentTypeId.toString(),
        });

        return this.get<FirstAvailableModel[]>(
            `${siteId}/availability/firstAvailable/${doctorId ? `user/${doctorId}` : 'all'}?${query}`
        );
    }

    public async GetBookingTimeslot(
        siteId: string | number,
        appointmentTypeId: string | number,
        doctorId: string | number | null | undefined,
        {
            startDate,
            endDate,
        }: {
            startDate: MomentInput;
            endDate: MomentInput;
        }
    ) {
        if (!appointmentTypeId) {
            return [];
        }
        const query = new URLSearchParams({
            appointmentTypeId: appointmentTypeId.toString(),
            startDate: moment(startDate).format('YYYY-MM-DD'),
            endDate: moment(endDate).format('YYYY-MM-DD'),
        });
        return this.get<SiteBookingAvailabilityModel[] | AutomedDoctorAvailablilityModel>(
            `${siteId}/availability/${doctorId ? `user/${doctorId}` : 'all'}?${query}`
        );
    }

    /** @deprecated Not sure if this works */
    public async GetDoctorDatesAndFirstAvailable(
        siteId: number,
        year: number,
        month: number,
        userId: number | string | undefined
    ) {
        const query = new URLSearchParams({
            year: year.toString(),
            month: month.toString(),
            userId: userId?.toString() ?? '',
        });
        return this.get<AutomedDoctorDateModel>(`${siteId}/availability/datesAndFirstAvailable?${query}`);
    }
}

export const availabilityService = new AvailabilityService();
export * from './types';
